import router from './index'
// import api from '@/api/onlineSchool'
import Vue from 'vue'

router.beforeEach(async(to, from, next) => {
    if(to.name === 'index') {
        const res = await Vue.prototype.$axios.post('/common/index/getOrgInfo',{
             domain: getDomain()
        //    domain: 'wx-adia.shanhuketang.com'
        })
        if(res.data.code === 200 && res.data.data.link) {
            // 判断用户是否使用魔方网校主页作为网校首页
            // Vue.prototype.$MO_FANG_URL = res.data.data.link
            const params = res.data.data.link.split('/').pop()
            const templateId = params.split('.')[0].split('_').pop()
            next({
                name: 'Home',
                query: { templateId: templateId }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

function getDomain() {
	if(process.env.NODE_ENV == 'development'){
        return 'wx-adia.tenghuiketang.com'
	} else {
       return window.location.host
    }
}